import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useSeo } from "@/components/site/Seo";
import { LogoMark } from "@/components/site/Logo";

export default function AdminLogin() {
  const { user, setUser } = useAuth();
  useSeo({ title: "Login", description: "", path: "/tigasatu", noindex: true });
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/tigasatu/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      nav("/tigasatu/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  const field = "w-full rounded-xl border border-white/10 bg-ink px-4 py-3.5 text-paper outline-none transition-colors focus:border-volt";
  return (
    <div className="grain grid min-h-screen place-items-center bg-ink px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="cut-corner w-full max-w-md bg-surface p-8 ring-1 ring-white/[0.07] md:p-10">
        <LogoMark className="h-10 w-10" />
        <h1 className="mt-6 font-display text-3xl font-bold text-paper">Panel Admin</h1>
        <p className="mt-2 text-sm text-zinc-400">Masuk untuk mengubah rate & info kontak.</p>
        <label className="mt-8 block text-sm text-zinc-300">Email</label>
        <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={`mt-2 ${field}`} />
        <label className="mt-5 block text-sm text-zinc-300">Password</label>
        <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={`mt-2 ${field}`} />
        {error ? <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">{error}</p> : null}
        <button data-testid="admin-login-submit" disabled={busy} className="mt-8 w-full rounded-full bg-volt py-3.5 font-semibold text-ink transition-transform hover:scale-[1.02] disabled:opacity-60">
          {busy ? "Memproses…" : "Masuk"}
        </button>
        <a href="/" data-testid="admin-back-home" className="mt-6 block text-center text-sm text-zinc-400 hover:text-paper">← Kembali ke website</a>
      </form>
    </div>
  );
}
